module.exports = new __parcel__URL__("tide.52e5a567.svg").toString();